import * as turf from '@turf/turf';

export const getPointFeature = (startPoint, distance, bearing) => {
    return turf.destination(startPoint, distance, bearing);
};

export const getCoordsPoint = (startPoint, distance, bearing) => {
    const point = turf.destination(startPoint, distance, bearing);

    return point.geometry && point.geometry.coordinates ? point.geometry.coordinates : [];
};

export const getCoordsBox = (centerPoint, radius) => {
    const hypotenuse = Math.sqrt(2) * radius;
    const topLeft = getCoordsPoint(centerPoint, hypotenuse, -45);
    const topRight = getCoordsPoint(centerPoint, hypotenuse, 45);
    const bottomRight = getCoordsPoint(centerPoint, hypotenuse, 135);
    const bottomLeft = getCoordsPoint(centerPoint, hypotenuse, -135);

    return [topLeft, topRight, bottomRight, bottomLeft];
};

export const metersToPixelsAtMaxZoom = (meters, latitude) => {
    return meters / 0.075 / Math.cos(latitude * Math.PI / 180);
};
